import { render } from "./CampaignLayout.vue?vue&type=template&id=d196d2e2&scoped=true"
import script from "./CampaignLayout.vue?vue&type=script&lang=js"
export * from "./CampaignLayout.vue?vue&type=script&lang=js"

import "./CampaignLayout.vue?vue&type=style&index=0&id=d196d2e2&scoped=true&lang=scss"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d196d2e2"]])

export default __exports__